function durationToDays(start, end) {
    const date1 = new Date('7/13/2010');
    const date2 = new Date('12/15/2010');
    const diffTime = Math.abs(end - start);
    return  Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export default durationToDays